module.exports = __webpack_public_path__ + "static/media/ChorusCountdown4Real.8542645d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Chorus/ChorusCountdown4Real.mp3
// module id = 121
// module chunks = 0